import { useState, useCallback } from 'react';
import { Photo } from '../../Hooks/UsePhotos';

export function usePhotoSelection() {
	const [selectedPhotos, setSelectedPhotos] = useState<Set<number>>(new Set());

	const isSelectMode = selectedPhotos.size > 0;

	const togglePhotoSelection = useCallback((photoId: number) => {
		setSelectedPhotos((prev) => {
			const newSet = new Set(prev);
			if (newSet.has(photoId)) {
				newSet.delete(photoId);
			} else {
				newSet.add(photoId);
			}
			return newSet;
		});
	}, []);

	const selectAllPhotos = useCallback((photos: Photo[]) => {
		const allPhotoIds = photos.map((photo) => photo.clientUploadId);
		setSelectedPhotos(new Set(allPhotoIds));
	}, []);

	const clearSelection = useCallback(() => {
		setSelectedPhotos(new Set());
	}, []);

	return {
		selectedPhotos,
		isSelectMode,
		togglePhotoSelection,
		selectAllPhotos,
		clearSelection,
	};
}
